import { render, staticRenderFns } from "./UnitPicker.vue?vue&type=template&id=2b5a6a66&scoped=true&"
import script from "./UnitPicker.vue?vue&type=script&lang=ts&"
export * from "./UnitPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@6.7.1_lodash@4.17.21_vue-template-compiler@2.7.14_webpack@5.73.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5a6a66",
  null
  
)

export default component.exports